module.exports = __webpack_public_path__ + "img/central-coast.02c43408.jpg";